import React, { FC, useMemo } from 'react';
import TextareaAutosize from 'react-textarea-autosize';
// Images
import LogoImage from 'assets/newLogos/upper-left-corner.png';
// Redux
import { useSelector } from 'react-redux';
import { selectorGetLiveScreen } from 'redux/dashboard-service/selector';
// Hooks
import { useLocales } from 'hooks/locales';
// Components
import { MediaSlider, MediaItem } from 'shared/components/MediaSlider';
// Styles
import cx from 'classnames';
import { formatInteger } from 'core/functions/formatNumber';
import styles from './LiveScreenForm.module.scss';

export const LiveScreenForm: FC = () => {
	const liveScreenInfo = useSelector(selectorGetLiveScreen);
	const { localeIdByKey } = useLocales();

	const { title, subTitle, mediaItems, interval } = useMemo(() => {
		const englishLocalized = liveScreenInfo?.dashboardLocalized?.find(
			item => Number(item.localeId) === Number(localeIdByKey.en)
		);
		return {
			title: englishLocalized?.titleLocalized || liveScreenInfo?.title || '',
			subTitle: englishLocalized?.subTitleLocalized || liveScreenInfo?.subTitle || '',
			mediaItems: ((liveScreenInfo?.mediaPathes || []) as MediaItem[]).filter(Boolean),
			interval: liveScreenInfo?.interval || 10,
		};
	}, [liveScreenInfo, localeIdByKey.en]);

	const convertedTime = useMemo(() => {
		return liveScreenInfo?.spendTime ? Math.round(liveScreenInfo.spendTime / 3600) : '';
	}, [liveScreenInfo?.spendTime]);

	return (
		<div className={styles.container}>
			<div className={styles.board}>
				<div className={styles.top}>
					<div className={styles.top__organization}>
						<img className={styles.top__organization__avatar} src={LogoImage} alt="avatar" />
					</div>
					<div className={styles.top__title_wrapper}>
						<TextareaAutosize className={styles.top__title} id="title" value={title} disabled />
					</div>
				</div>

				<div className={cx(styles.card, styles.card_first)}>
					<span className={styles.card__title}>World wide hours</span>
					<span className={styles.card__count}>
						{convertedTime === '' ? '' : formatInteger(convertedTime)}
					</span>
				</div>

				<div className={cx(styles.card, styles.card_second)}>
					<span className={styles.card__title}>Total Opportunities</span>
					<span className={styles.card__count}>{formatInteger(liveScreenInfo?.opportunitiesCount)}</span>
				</div>

				<div className={cx(styles.card, styles.card_third)}>
					<span className={styles.card__title}>Volunteer spotlight</span>
					{liveScreenInfo?.recentlyVolunteerName ? (
						<div className={styles.card__volunteer}>
							<div className={styles.card__volunteer__avatar}>
								{liveScreenInfo?.recentlyVolunteerName.split('').join(' ')}
							</div>
						</div>
					) : null}
					{liveScreenInfo?.recentlyOppoName ? (
						<div
							className={cx(styles.card__subTitle, styles.recentlyOppo, {
								[styles.card__volunteer__oppo_padding]:
									liveScreenInfo?.recentlyVolunteerName.trim().length >= 43,
								[styles.card__volunteer__oppo]: liveScreenInfo?.recentlyOppoName.trim().length >= 38,
							})}
							title={liveScreenInfo?.recentlyOppoName}
						>
							<span className={styles.card__subTitle_bold}>Opportunity: </span>
							<span className={styles.card__opponame}>{liveScreenInfo?.recentlyOppoName}</span>
						</div>
					) : null}
				</div>

				<div className={styles.bottom}>
					<img src={LogoImage} className={styles.bottom__avatar} alt="logo" />
					<TextareaAutosize className={styles.bottom__subTitle} id="subTitle" value={subTitle} disabled />
				</div>
				<div className={styles.media}>
					<div className={styles.media__slider_wrapper}>
						<MediaSlider
							mediaItems={mediaItems}
							editMode={false}
							autoplayDelay={interval}
							showUploadSlide={false}
							className={styles.media__slider}
						/>
					</div>
				</div>
			</div>
		</div>
	);
};
